import { createAction } from '@reduxjs/toolkit';

import { ACTIONS } from './constants';
import {
  CartDataType,
  CategoryItemType,
  CityType,
  ProductTypeExtended,
  TempCartItemType,
} from '@/types';
import { DeletedCartItem } from './types';

export const setMenuActive = createAction<boolean>(ACTIONS.SET_MENU_ACTIVE);

export const setCityPopupActive = createAction<boolean>(
  ACTIONS.SET_CITY_POPUP_ACTIVE,
);

export const setSelectCityDrawerActive = createAction<boolean>(
  ACTIONS.SET_SELECT_CITY_DRAWER,
);

export const setCity = createAction<CityType>(ACTIONS.SET_CITY);

export const setMenuSearchActive = createAction<boolean>(
  ACTIONS.SET_MENU_SEARCH_ACTIVE,
);

export const setSearchActive = createAction<boolean>(ACTIONS.SET_SEARCH_ACTIVE);

export const setAuthDrawerActive = createAction<boolean>(
  ACTIONS.SET_AUTH_DRAWER_ACTIVE,
);

export const setFavouriteProducts = createAction<ProductTypeExtended[]>(
  ACTIONS.SET_FAVOURITE_PRODUCTS,
);

export const setCartData = createAction<CartDataType>(ACTIONS.SET_CART_DATA);

export const setCartDrawerActive = createAction<boolean>(
  ACTIONS.SET_CART_DRAWER_ACTIVE,
);

export const setAvailableLocations = createAction<CityType[]>(
  ACTIONS.SET_AVAILABLE_LOCATIONS,
);

export const setCategoryTree = createAction<CategoryItemType[]>(
  ACTIONS.SET_CATEGORY_TREE,
);

export const setTempCartItems = createAction<TempCartItemType[]>(
  ACTIONS.SET_TEMP_CART_ITEMS,
);

export const setOrderUserCorrect = createAction<boolean>(
  ACTIONS.SET_ORDER_USER_CORRECT,
);

export const setOrderDeliveryCorrect = createAction<boolean>(
  ACTIONS.SET_ORDER_DELIVERY_CORRECT,
);

export const setOrderCompanyInvoiceCorrect = createAction<boolean>(
  ACTIONS.SET_ORDER_COMPANY_INVOICE_CORRECT,
);

export const setCatalogActive = createAction<boolean>(
  ACTIONS.SET_CATALOG_ACTIVE,
);

export const setPartnersDrawerActive = createAction<boolean>(
  ACTIONS.SET_PARTNERS_DRAWER_ACTIVE,
);

export const setDeletedCartItems = createAction<DeletedCartItem[]>(
  ACTIONS.SET_DELETED_CART_ITEMS,
);

export const addDeletedCartItem = createAction<DeletedCartItem>(
  ACTIONS.ADD_DELETED_CART_ITEM,
);

export const removeDeletedCartItem = createAction<string>(
  ACTIONS.REMOVE_DELETED_CART_ITEM,
);

export const setAlert = createAction<any>(ACTIONS.SET_ALERT);

export const setHeaderButtonColor = createAction<string>(
  ACTIONS.SET_HEADER_BUTTON_COLOR,
);

export const setHelpDrawerActive = createAction<boolean>(
  ACTIONS.SET_HELP_DRAWER_ACTIVE,
);

export const setHelpDrawerScreen = createAction<string>(
  ACTIONS.SET_HELP_DRAWER_SCREEN,
);
